import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BizService } from 'src/app/services/biz.service';
import { LanguageService } from 'src/app/services/language.service';
import { SwalWithDefaults } from 'src/shared/swal-dialog-default-options';

@Component({
  selector: 'app-forgot-password',
  standalone: false,
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css'
})
export class ForgotPasswordComponent {

  loading = false;
  requestSent = false;
  userName: string = "";

  constructor(private bizService: BizService,
              private router: Router,
              private languageService: LanguageService) {
  }

  async ResetPassword()
  {
    this.loading = true;

    let language = this.languageService.getCurrentLang();

    try {
      const success = await this.bizService.ResetPassword(this.userName, language);
      if (success) {
        SwalWithDefaults.fire({
            title: this.languageService.getTranslation('Main.ForgotPassword.EmailSentIfAccountExists'),
            icon: 'success'
          });
      }
      else {
        SwalWithDefaults.fire({
          title: this.languageService.getTranslation('Main.ForgotPassword.Error'),
          icon: 'error'
        });
      }

    } catch (error) {
      SwalWithDefaults.fire({
        title: this.languageService.getTranslation('Main.ForgotPassword.Error'),
        icon: 'error'
      });
    }

    this.loading = false;
    this.requestSent = true;
  }

  BackToLogin(): void
  {
    this.router.navigate(['/']);
  }
}
